import React from 'react';

import { Box, Button, Image, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { ComponentInfo } from '@components';
import { rem } from '@helpers';

import { useServiceErrorHelper } from './serviceError.helper';

export const ServiceErrorPlaceholder: React.FC = () => {
	const { imageProps, resources, onClickHandler } = useServiceErrorHelper();

	return (
		<ComponentInfo name="ServiceErrorPlaceholder" type="placeholder">
			<Box
				styles={{
					width: '100%',
					marginTop: rem(69.03),
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Image {...imageProps} />
			</Box>
			<Box
				styles={{
					display: 'flex',
					flexDirection: 'column',
					width: '100%',
					marginTop: rem(37.03),
					textAlign: 'center',
					marginBottom: rem(30),
				}}
			>
				<Typography appearance="headline-100-03">{resources.message}</Typography>
			</Box>
			<Box styles={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
				<Button onPress={onClickHandler}>{resources.button}</Button>
			</Box>
		</ComponentInfo>
	);
};
